module.exports = __webpack_public_path__ + "img/client15.1b1ecdab.png";